import * as React from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import ArtPreview from "../../core/ui/art-preview";
import Grid, { Col } from "../../core/ui/grid";
import Pagination from "../../core/ui/pagination";
import {PageSize} from "./arts";
import { IGalleryItem } from "../../typings";

export interface GalleryViewProps {
  data: IGalleryItem[];
  header?: React.ReactNode;
  colNumber?: number;
  total: number;
  currentPage: number;
  load: (pageSize?: number, pageNumber?: number) => void;
  showWarning?: boolean;

  urlPreffix: string;
  showTemplate?: boolean;
}

export default class GalleryView extends React.Component<GalleryViewProps, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  public load = (pageSize, i) => {
    this.setState({loading: true});
    this.props.load(pageSize, i);
    this.setState({loading: false});
  }

  public render() {

    let size = this.props.colNumber || 3;

    let cols: any[][] = [];

    for (let i = 0 ; i < size; i++) {
      cols.push([]);
    }

    if (this.props.header) {
      cols[0].push(this.props.header);
    }

    let delta = this.props.header ? 1 : 0;

    for (let i = delta ; i < this.props.data.length + delta; i++) {
        cols[i % size].push(
            <ArtPreview
                showTemplate={this.props.showTemplate}
                urlPreffix={this.props.urlPreffix}
                showWarning={this.props.showWarning}
                key={i - delta + "item"}
                model={this.props.data[i - delta]}
            />);
    }

    return (
      <div className="gallery-grid">
        {this.props.data.length == 0 && !this.props.header && <h1 className="not-found-message">No tokens found</h1>}
        <Grid  type="fill" fillCount={size} centered={true} className="wrap">
              {cols.map((item, index) => {

                return (<TransitionGroup className="fill-column" key={"fill-col" + index}>
                  {
                    item.map((prev, j) => {
                      return  (<CSSTransition
                                  classNames="preview"
                                  timeout={500}
                                  key={j}
                              >{prev}</CSSTransition>); })

                }</TransitionGroup>);
              })
            }
        </Grid>
        <Pagination
        onChange={(i) => this.load(PageSize, i)}
        currentPage={this.props.currentPage} total={this.props.total} pageSize={PageSize} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/arts/gallery-grid.view.tsx